module.exports = __webpack_public_path__ + "img/20240626-110619.f4e1fafb.png";